<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('设备名称')" prop="devName">
                <a-input v-model="queryParam.devName" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('设备编号')" prop="devCode">
                <a-input v-model="queryParam.devCode" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('时间')" prop="devCode">
                <cy-range-picker
                  :start.sync="queryParam.createBeginTime"
                  :end.sync="queryParam.createEndTime"
                ></cy-range-picker>
              </a-form-item>
            </a-col>
            <template v-if="advanced"> </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <!--            <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['cooking:dev:add']">
          <a-icon type="plus" />{{ $t('新增') }}
        </a-button>
        <!-- <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['problem:type:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button> -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['cooking:dev:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['cooking:dev:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <a-button type="primary" @click="handleExportTemplate" v-hasPermi="['cooking:dev:export']">
          <a-icon type="download" />{{ $t('导出上传模板') }}
        </a-button>
        <a-upload
          ref="upload-import"
          name="file"
          :fileList="fileList"
          :action="baseUrl + '/cooking/cooking-dev/import'"
          :headers="{
            Authorization: 'Bearer ' + $store.getters.token
          }"
          @change="handleChange"
          v-hasPermi="['cooking:dev:import']"
        >
          <a-button> <a-icon type="upload" /> {{ $t('导入') }} </a-button>
        </a-upload>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form v-if="visible" ref="createForm" @refresh="getList" @close="visible = false" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <a-popconfirm :ok-text="$t('是')" :cancel-text="$t('否')" @confirm="handleStatusType(record)">
            <span slot="title"
              >{{ $t('确认') }}<b>{{ record.status === 0 ? $t('启用') : $t('停用') }}</b> {{ record.title
              }}{{ $t('的类型吗?') }}
            </span>
            <a-switch :checked-children="$t('开')" :un-checked-children="$t('关')" :checked="record.status === 1" />
          </a-popconfirm>
        </span>
        <span slot="online" slot-scope="text, record">
          <a-tag :color="filterCommon(record.online, onlineArr, 'color')">{{
            record.online | filterCommon(onlineArr, 'label')
          }}</a-tag>
        </span>
        <span slot="devImg" slot-scope="text, record">
          <div v-viewer>
            <img v-if="record.devImg" style="width: 20px; height: 20px" :src="record.devImg" alt="" />
          </div>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['cooking:dev:edit']" />
          <a @click="handleAdd(record.id)" v-hasPermi="['cooking:dev:edit']">
            <a-icon type="edit" />{{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['cooking:dev:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['cooking:dev:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `${$t('共')} ${total} ${$t('条')}`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delObj, fetchList } from './api'
import CreateForm from './modules/CreateForm'
import CyRangePicker from '@/components/CyRangePicker'
import { tableMixin } from '@/store/table-mixin'
import { filterCommon } from '@/utils/filter'

export default {
  name: 'Type',
  components: {
    CreateForm,
    CyRangePicker
  },
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      visible: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        devCode: undefined,
        devName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      onlineArr: [
        { value: 0, label: this.$t('离线'), color: 'red' },
        { value: 1, label: this.$t('在线'), color: 'blue' }
      ],
      columns: [
        { title: this.$t('设备名称'), dataIndex: 'devName', align: 'center', ellipsis: true },
        { title: this.$t('设备编号'), dataIndex: 'devCode', align: 'center', ellipsis: true },
        {
          title: this.$t('设备图片'),
          dataIndex: 'devImg',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'devImg' }
        },
        {
          title: this.$t('在线状态'),
          dataIndex: 'online',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'online' }
        },
        { title: this.$t('炉头数'), dataIndex: 'remark', align: 'center', ellipsis: true },
        { title: this.$t('用户名称'), dataIndex: 'userName', align: 'center', ellipsis: true },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      fileList: []
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    filterCommon,
    handleAdd(id) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.createForm.init(id)
      })
    },
    /** 查询常见问题分类列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        devCode: undefined,
        devName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t(this.$t('提示')),
        onOk() {
          const data = []
          that.ids.map((id) => data.push({ id: id }))
          delObj(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(this.$t('删除成功'), 3)
          })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleChange(info) {
      const status = info.file.status
      this.fileList = info.fileList
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        if (info.file.response.code === '20001') {
          this.$message.success(this.$t('上传成功'))
          this.fileList = []
          this.getList()
        } else {
          this.$message.error(info.file.response.message)
          this.fileList = []
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
        this.fileList = []
      }
    },
    /* 导入设备 */
    handleImport() {
      this.$confirm({
        title: this.$t('导入设备'),
        content: (h) => (
          <a-upload-dragger
            name="file"
            multiple={false}
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            onChange={this.handleChange}
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">Click or drag file to this area to upload</p>
            <p class="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files
            </p>
          </a-upload-dragger>
        ),
        onOk: () => {},
        onCancel: () => {}
      })
    },
    /** 导出上传模版按钮操作 */
    handleExportTemplate() {
      var that = this
      this.$confirm({
        title: this.$t(this.$t('是否确认导出?')),
        content: this.$t(this.$t('此操作将导出当前条件下所有数据而非选中数据')),
        onOk() {
          that.download(
            '/cooking/cooking-dev/export ',
            {
              ...that.queryParam
            },
            `device_${new Date().getTime()}.xls`
          )
        },
        onCancel() {}
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t(this.$t('是否确认导出?')),
        content: this.$t(this.$t('此操作将导出当前条件下所有数据而非选中数据')),
        onOk() {
          that.download(
            '/cooking/cooking-dev/export/dev',
            {
              ...that.queryParam
            },
            `device_${new Date().getTime()}.xls`
          )
        },
        onCancel() {}
      })
    }
  }
}
</script>
